import {
  ChangeDetectorRef,
  DestroyRef,
  Directive,
  EmbeddedViewRef,
  inject,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { transformToArray } from './utils';
import { Observable } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

/**
 * Because transformToArray accepts generic and angular transforms don't, we use this helper function
 */
export function transformString(value: string | string[]): string[] {
  return transformToArray(value);
}

@Directive()
export abstract class UpdateViewBase {
  protected templateRef = inject(TemplateRef);
  protected viewContainer = inject(ViewContainerRef);
  protected destroyRef = inject(DestroyRef);
  protected cdr = inject(ChangeDetectorRef);

  private _embeddedView: EmbeddedViewRef<any>;

  protected updateView(permissions: string | string[]) {
    this.checkFn$(permissions)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((valid) => {
        if (valid) {
          if (this._embeddedView) {
            this.viewContainer.clear();
          }

          this._embeddedView = this.viewContainer.createEmbeddedView(
            this.templateRef
          );

          this.cdr.markForCheck();
        } else {
          this.viewContainer.clear();
        }
      });
  }

  abstract checkFn$(permissions: string | string[]): Observable<boolean>;
}
